import Login from '../components/Login/Login';
import Layout from '../components/Layout/Layout';

/**
 * Lazy Routes
 */
 /* eslint-disable global-require */
const Home = (resolve) => {
  require.ensure(['../components/Home/Home'], () => {
    resolve(require('../components/Home/Home'));
  });
};

const Survey = (resolve) => {
  require.ensure(['../components/Survey/Survey'], () => {
    resolve(require('../components/Survey/Survey'));
  });
};

const ResetPassword = (resolve) => {
  require.ensure(['../components/Forms/ResetPassword'], () => {
    resolve(require('../components/Forms/ResetPassword'));
  });
};

const ThankUser = (resolve) => {
  require.ensure(['../components/thankUser'], () => {
    resolve(require('../components/thankUser'));
  });
};

/* eslint-enable global-require */

// Routes
const routes = [
  { path: '/',
    component: Login,
    name: 'Login',
    children: [
      { path: '/:username/:password', component: Login },
    ],
  },
  { path: '/home',
    component: Layout,
    children: [
      { path: '/', component: Home },
      { path: '/:id', component: Survey },
      { path: 'user/resetPassword', component: ResetPassword },
      { path: 'user/thankuser', component: ThankUser },
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js